import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CharReveal, Reveal } from './TerminalEffects';

const images = [
  {
    src: 'https://images.unsplash.com/photo-1739298061707-cefee19941b7?w=600&h=400&fit=crop',
    alt: 'Team collaborating around a table'
  },
  {
    src: 'https://images.unsplash.com/photo-1758691736843-90f58dce465e?w=600&h=400&fit=crop',
    alt: 'Diverse team brainstorming with sticky notes'
  },
  {
    src: 'https://images.unsplash.com/photo-1752650735943-d0fbf1edce21?w=600&h=400&fit=crop',
    alt: 'Two colleagues working together on a project'
  },
];

export const CollaborationStrip = () => {
  return (
    <section className="relative py-24 bg-[#F5F0E0] overflow-hidden">
      <div className="absolute top-0 left-6 right-6 lg:left-[calc(50%-600px)] lg:right-[calc(50%-600px)] h-px bg-[#2A2A2A]/10" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <Reveal direction="right">
          <div className="space-y-6">
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A]">
              Built for Teams
            </p>
            <CharReveal text="Empower Your Team" tag="h2"
              className="text-4xl sm:text-5xl font-semibold text-[#2A2A2A] leading-[1.05]" />
            <p className="text-base text-[#2A2A2A]/60 leading-relaxed max-w-[480px]" style={{ fontFamily: "'Manrope', sans-serif" }}>
              While your AI receptionist handles calls and bookings, your team can focus on delivering exceptional service and growing your business.
            </p>
            <Link
              to="/onboarding"
              className="inline-flex items-center gap-2.5 bg-[#2A2A2A] text-white px-7 py-3 rounded-full text-xs font-mono uppercase tracking-[0.12em] hover:scale-105 hover:shadow-[0_0_30px_rgba(0,255,209,0.15)] transition-all duration-300 group"
              data-testid="collab-cta"
            >
              Get Started Free
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          </Reveal>

          {/* Right: B&W Image Grid */}
          <Reveal delay={200} direction="left">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={images[0].src} alt={images[0].alt}
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
              </div>
              <div className="rounded-2xl overflow-hidden aspect-square bg-[#00FFD1]/10 flex items-center justify-center p-6">
                <div className="text-center">
                  <p className="text-4xl font-bold text-[#2A2A2A]">40%</p>
                  <p className="text-xs font-mono uppercase tracking-wider text-[#2A2A2A]/60 mt-2">More Bookings</p>
                </div>
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="rounded-2xl overflow-hidden aspect-square bg-[#C4956A]/15 flex items-center justify-center p-6">
                <div className="text-center">
                  <p className="text-4xl font-bold text-[#2A2A2A]">24/7</p>
                  <p className="text-xs font-mono uppercase tracking-wider text-[#2A2A2A]/60 mt-2">Always Available</p>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={images[1].src} alt={images[1].alt}
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
              </div>
            </div>
          </div>
          </Reveal>
        </div>

        {/* Full Width B&W Image */}
        <Reveal delay={100}>
        <div className="mt-12 rounded-2xl overflow-hidden aspect-[3/1] max-h-[280px]">
          <img src={images[2].src} alt={images[2].alt}
            className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
        </div>
        </Reveal>
      </div>
    </section>
  );
};
